<main class="auth-wrapper lu-row"
[attr.aria-label]="!layoutConfig.portalName ? title : title + ' ' + layoutConfig.portalName"
[class.auth-wrapper-center]="layoutConfig.fullScreen"
[class.auth-wrapper--embed]="layoutConfig.embed"
>
	<section class="auth-side col md-5 sm-12">
		<ng-content *ngIf="layoutConfig.embed; else defaultCoverTemplate"
			select="[embedCover]">
		</ng-content>

		<ng-template #defaultCoverTemplate>
			<div class="auth-side__wrapper" [class.auth-side__wrapper--small-header]="layoutConfig.login_welcome_message">
				<angie-logo
					size="md"
					[linkType]="'routerLink'"
					[link]="'/users/sign_in'"
					[altTag]="layoutConfig.logo_alt"
					position="center"></angie-logo>
			</div>
			<div *ngIf="layoutConfig.login_welcome_message" [innerHTML]="safeHtml" class="ck-wrapper"></div>
		</ng-template>
	</section>

	<section class="main-content col md-7 sm-12" [class.main-content--embed]="layoutConfig.embed" *ngIf="!layoutConfig.fullScreen">
		<header class="main-content__top-nav hdn-to-sm" *ngIf="layoutConfig.allow_user_to_self_register">
			<ng-content select="[signUp]"></ng-content>
		</header>
		<div class="main-content__form-wrapper">
			<h1 class="main-content__title" [class.main-content__title--embed]="layoutConfig.embed" [class.mb-48]="layoutConfig.embed" [class.small-size]="layoutConfig?.custom_sign_into_text?.length > 50">
				<ng-container *ngIf="!layoutConfig.custom_sign_into_text; else customSignInText">
					{{ title }} <span class="main-content__title-two-line" *ngIf="layoutConfig.portalName">{{ layoutConfig.portalName }} </span>
				</ng-container>
				<ng-template #customSignInText>
					{{ layoutConfig.custom_sign_into_text}}
				</ng-template>
			</h1>
			<ng-content select="[infoBox]"></ng-content>
			<form class="main-content__form" [formGroup]="form.formGroup">
				<formly-form [model]="form.model" [fields]="form.fields" [form]="form.formGroup"></formly-form>
				<ng-content select="[forgotPassword]"></ng-content>
				<div class="primary-action" [class.primary-action--embed]="layoutConfig.embed">
					<ng-content select="[primaryAction]"></ng-content>
				</div>
			</form>
			<ng-content select="[secondaryAction]"></ng-content>
			<ng-content select="[recaptcha]"></ng-content>
			<ng-content select="[customLogin]"></ng-content>
			<div class="privacy-container">
				<ng-content select="[privacy]"></ng-content>
			</div>
			<div class="bottom-action" *ngIf="layoutConfig.allow_user_to_self_register">
				<ng-content select="[signUpBottom]"></ng-content>
			</div>
		</div>
	</section>
</main>
<!-- <ng-container *ngIf="!layoutConfig.terms?.title">
	<div class="line"></div>
	<div class="wrapper o-flex o-flex--center">
		<a>Terms and Conditions</a>
	</div>
</ng-container> -->

